import React from 'react';
import s from './adGod.scss';
// import { XPSPromotionInstance, isXPSPromotionInstance, PromotionInstance } from '../../models/apis/promotion';
// import { FeedInstance } from '../../models/feed';
// import { CisItem, isXPSAdInstance, XPSAdInstance } from '../../models/apis/batchCisApi'
import { XPSPromotionInstance, isXPSPromotionInstance, PromotionInstance } from '../../models/apis/promotion';
import { FeedInstance } from '../../models/feed';
import { genPCMCode } from '../../utils/spmHelper';
import { LinkWrapper } from '../BaseComp';

interface Props {
    // dataSources: Array<CisItem[]>,
    dataSources: Array<Array<FeedInstance | PromotionInstance>>,
    spmCode: string,
    miscellaneous: string[],
}

export const PureTextAdBanner = (props: Props) => {
    const { dataSources, spmCode, miscellaneous } = props;
    const active = 0;
    const adGroups: XPSPromotionInstance[][] = dataSources.map(group => group.filter(e => isXPSPromotionInstance(e))) as XPSPromotionInstance[][];
    const pos: number[][] = Array(3).fill(Array(10).fill(1));
    return (
        <div className={s.pureTextContainer} data-asm-new-slider="true">
            <div className={[s.displayGods, 'slider-wrapper'].join(' ')} >
                {
                    pos.map((posGroup, i) => {
                        const group = (adGroups[i] || []).filter(e => isXPSPromotionInstance(e));
                        return (
                            <div className={[s.godsGroup, 'slider-item', i === active ? 'active' : ''].join(' ')} key={i} data-spm={`${spmCode}-${i + 1}`} data-god-index-provider={i}>
                                {
                                    posGroup.map((_, index) => {
                                        const ad = group[index];
                                        const placeholder = miscellaneous[10 * i + index];
                                        // TODO: use godbox instead
                                        if (ad) {
                                            return (
                                                <div
                                                    key={index}
                                                    className={s.godText}
                                                    data-god-id={ad.adData.itemspaceid}
                                                    data-god-ps={ad.adData.adps}
                                                    data-w="130"
                                                    data-h="01"
                                                    data-maxreads={ad.adData.maxreads}
                                                    data-turn={ad.adData.turn}
                                                    data-spm-type="resource"
                                                    data-spm-content={genPCMCode(ad)}
                                                >
                                                    <LinkWrapper
                                                        href={`//search.sohu.com/?keyword=${encodeURIComponent(miscellaneous[10 * i + index])}&type=1&queryType=hot-query`}>
                                                        {miscellaneous[10 * i + index]}
                                                    </LinkWrapper>
                                                </div>
                                            );
                                        }
                                        if (!placeholder) { return null; }
                                        return (
                                            <div
                                                key={index}
                                                className={s.godText}
                                            >
                                                <LinkWrapper
                                                    href={`//search.sohu.com/?keyword=${encodeURIComponent(miscellaneous[10 * i + index])}&type=1&queryType=hot-query`}>
                                                    {miscellaneous[10 * i + index]}
                                                </LinkWrapper>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })
                }
                <span className="god-mark">广告</span>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/AdGod/PureTextBanner.tsx